import { useContext } from 'react';
import { currentRenderDirectionContext } from './context';
export var useCurrentRenderDirection = function () {
    var currentDimension = useContext(currentRenderDirectionContext);
    return currentDimension;
};
